import React, {useEffect} from 'react';

import * as Yup from 'yup';
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {fetchAllBranches} from "../../../../Base/_redux/branches/branchesActions";
import {Field, Form, Formik} from "formik";
import {Input, Select} from "../../../../../../_metronic/_partials/controls";


const NoticeCreateSchema = Yup.object().shape({
    name: Yup.string().required('لطفا یک نام وارد کنید'),
    description: Yup.string(),
    type: Yup.string().required('لطفا نوع اطلاعیه را انتخاب کنید'),
    branchId: Yup.string()
        .when('type', {
            is: '1',
            then: Yup.string().required('لطفا یک شعبه انتخاب کنید')
        })
})

const initialValues = {
    name: '',
    description: '',
    type: '0',
    branchId: ''
}

export function NoticeCreateForm({
    btnRef,
    createNotice
                                 }) {

    const {branches, branchesLoading} = useSelector((state) => {
        return {
            branches: state.branches.entities,
            branchesLoading: state.branches.listLoading
        }
    }, shallowEqual);

    const dispatch = useDispatch();


    useEffect(() => {
        dispatch(fetchAllBranches());
    }, [dispatch]);
    
    
    return(
        <>
            
            <Formik initialValues={initialValues} onSubmit={(values) => createNotice(values)}
                    validationSchema={NoticeCreateSchema}
                    enableReinitialize={true}>
                {({handleSubmit, values}) => (
                    <>

                        <Form className={"form form-label-right"}>
                            <div className={"form-group row px-4"}>
                                <div className={"col-lg-6 mb-1"}>
                                    <Field
                                        name={"name"}
                                        component={Input}
                                        placeholder={"عنوان اطلاعیه"}
                                        label={"نام"}
                                    />
                                </div>

                                <div className={"col-lg-6 mb-1"}>
                                    <Select
                                        name={"type"}
                                        label={"نوع اطلاعیه"}
                                        withFeedbackLabel
                                    >
                                        <option value={"0"}>عمومی</option>
                                        <option value={"1"}>شعبه مشخص</option>
                                    </Select>
                                </div>
                                {values.type === "1" && (
                                    <div className={"col-lg-6 mb-1"}>
                                        <Select
                                            name={"branchId"}
                                            label={"شعبه"}
                                            withFeedbackLabel
                                        >
                                            <option value={""}>لطفا یک شعبه را انتخاب کنید</option>
                                            {branches && branches.map(branch => (
                                                <option key={branch.id} value={branch.id}>
                                                    {branch.name}
                                                </option>
                                            ))}
                                        </Select>
                                    </div>
                                )}
                                <div className={"col-lg-12"}>
                                    <Field
                                        name={"description"}
                                        component={Input}
                                        placeholder={"توضیحات اطلاعیه"}
                                        label={"توضیحات"}
                                    />
                                </div>
                            </div>
                            <button
                                type={"submit"}
                                style={{display: "none"}}
                                ref={btnRef}
                                onSubmit={() => handleSubmit()}
                            />
                        </Form>

                    </>
                )}
            </Formik>

        </>
    )


}